export const kidsBadgeAsset = `https://wwwimage-us.pplusstatic.com/base/files/cbs_page_attribute/user-profile-badge-kids.svg`;
export const kidsAvatarAsset = `https://wwwimage-us.pplusstatic.com/thumbnails/photos/w180-q80/profile/emotions_giant_cyclops.png`;
export const addProfilePicAsset = `https://wwwimage-secure.cbsstatic.com/base/files/asset/10/00/96/99/b5b795fad8328cbc_add.png`;
